<script setup lang="ts">
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import { QA_TABLES } from '@modules/tables/constants';

import type { ITableMobileSearchEmits, ITableMobileSearchProps } from './types';
import VTableMobileMenu from '../VTableMobileMenu/VTableMobileMenu.vue';
import VTableSearch from '../VTableSearch/VTableSearch.vue';

defineProps<ITableMobileSearchProps>();
const emit = defineEmits<ITableMobileSearchEmits>();

function onSearch(value: string): void {
  emit('search-update', value);
}
</script>

<template>
  <VTableMobileMenu v-data-qa-auto-id="'VTableMobileSearch'"
    min-width="250px"
    no-padding-list
  >
    <template #default="{ openMenu }">
      <VIconButton
        v-data-test="{ el: QA_TABLES.mobileSearchMenu }"
        icon="pi pi-search"
        class="font-bold text-muted-color"
        :class="{ '!text-primary': !!tableState.search?.keyword }"
        @click="openMenu($event)"
      />
    </template>
    <template #search>
      <VTableSearch
        :search-query="searchQuery"
        :disabled="disabled"
        @search-update="onSearch"
      />
    </template>
  </VTableMobileMenu>
</template>
